module.exports = __webpack_public_path__ + "img/20.9b017e95.jpg";